'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/bundles/items-bundle-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { PackageSizesModal } from '@marketplace-web/shipping/package-size-feature'

type Props = ConversationActionProps

const ConfirmPackageSize = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()

  const transactionId = useConversationContext().conversation?.transaction?.id
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openPackageSizeSelectionModal = () => setIsModalOpen(true)

  const handleClosePackageSizeSelectionModal = () => setIsModalOpen(false)

  const trackOpenPackageSizeSelectionModal = () =>
    track(
      clickEvent({
        screen: 'message_reply',
        target: 'pick_package_size',
        targetDetails: JSON.stringify({
          transaction_id: transactionId,
        }),
      }),
    )

  const handleSelectPackageSize = () => {
    openPackageSizeSelectionModal()
    trackOpenPackageSizeSelectionModal()
  }

  if (!transactionId) return null

  return (
    <>
      <ConversationActionButton
        primary={primary}
        onClick={handleSelectPackageSize}
        text={title}
        size={size}
        theme={theme}
        inverse={inverse}
        testId="confirm-package-size-button"
      />
      <PackageSizesModal
        isOpen={isModalOpen}
        transactionId={transactionId}
        onClose={handleClosePackageSizeSelectionModal}
      />
    </>
  )
}

export default ConfirmPackageSize
